<template>
  <div class="tag-container">
    <el-scrollbar wrap-class="tag-bar-list">
      <router-link v-for="tag in visitedViews" ref="tag" :key="tag.path" :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" tag="span" class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)" @contextmenu.prevent.native="openMenu(tag, $event)">
        {{ tag.tagName }}
        <span v-if="!tag.meta.fixTag" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></span>
      </router-link>
    </el-scrollbar>
    <div class="tag-operation-menu" v-if="tagMenuVisible" :style="{ left: menuRect.x, top: menuRect.y }">
      <div v-if="!currentTag.meta.fixTag" class="menu-operate" @click.stop="closeSelectedTag(currentTag)">
        <span>关闭标签</span>
      </div>
      <div class="menu-operate" @click.stop="closeRightTags(currentTag)"><span>关闭右侧标签</span></div>
      <div class="menu-operate" @click.stop="closeOtherTags(currentTag)"><span>关闭其他标签</span></div>
    </div>
  </div>
</template>

<script>
import path from 'path'

export default {
  name: 'TagsBar',
  data() {
    return {
      tagMenuVisible: false,
      menuRect: { x: 0, y: 0 },
      currentTag: ''
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tag.visitedViews
    },
    routes() {
      return this.$store.state.permit.userTree
    }
  },
  mounted() {
    this.initTags()
    //将当前页面添加进去
    this.addTags()
    this.listener()
  },
  watch: {
    $route() {
      this.addTags()
    }
  },
  methods: {
    listener() {
      window.addEventListener('click', () => {
        this.tagMenuVisible = false
      })
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    openMenu(tag, $event) {
      this.menuRect = { x: $event.x + 'px', y: $event.y + 'px' }
      this.currentTag = tag
      this.tagMenuVisible = true
    },
    closeRightTags(tag) {
      this.$store.dispatch('delRightViews', tag).then((visitedViews) => {
        let activeItem = visitedViews.find((item) => {
          return this.isActive(item)
        })
        if (!activeItem) {
          this.toLastView(visitedViews)
        }
      })
      this.tagMenuVisible = false
    },
    closeOtherTags(tag) {
      this.$store.dispatch('delOthersViews', tag).then((visitedViews) => {
        this.toLastView(visitedViews)
      })
      this.tagMenuVisible = false
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes &&
        routes.forEach((route) => {
          if (route.meta && route.meta.fixTag) {
            const tagPath = path.resolve(basePath, route.path)
            tags.push({
              fullPath: tagPath,
              path: tagPath,
              name: route.name,
              tagName: route.meta.tagName || route.meta.title,
              meta: { ...route.meta }
            })
          }
          if (route.children) {
            const tempTags = this.filterAffixTags(route.children, route.path)
            if (tempTags.length >= 1) {
              tags = [...tags, ...tempTags]
            }
          }
        })
      return tags
    },
    initTags() {
      const fixTags = this.filterAffixTags(this.routes)
      // debugger
      for (const tag of fixTags) {
        if (tag.meta.tagName || tag.meta.title) {
          this.$store.dispatch('addView', tag)
        }
      }
    },
    closeSelectedTag(view) {
      // const keepUrl = '/engineeringProjectSetting/engineeringAudit'
      // const keepUrl1 = '/engineeringProjectSetting/engineeringApprove'
      this.$store.dispatch('delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews)
          // if (view.path === keepUrl) localStorage.removeItem('engineeringAuditDetail')
          // if (view.path === keepUrl1) localStorage.removeItem('engineeringApproveDetail')
        }
      })
      this.tagMenuVisible = false
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        this.$router.push('/')
      }
    },
    addTags() {
      const { meta } = this.$route
      if (meta && (meta.title || meta.tagName)) {
        this.$store.dispatch('addView', this.$route)
      }
    }
  }
}
</script>

<style scoped>
.tags-view-item {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 4px;
  user-select: none;
}

.tags-view-item:first-of-type {
  margin-left: 0;
}

.tags-view-item:last-of-type {
  margin-right: 0;
}

.tags-view-item.active {
  background-color: #4d7cff;
  color: #fff;
  border-color: #4d7cff;
}

.tags-view-item.active::before {
  content: '';
  background: #fff;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: relative;
  margin-right: 2px;
}

.menu-operate+.menu-operate {
  border-top: 1px solid #eee;
}


.tag-operation-menu {
  position: fixed;
  width: 120px;
  padding: 0 0;
  background-color: #fff;
  z-index: 10;
  border-radius: 5px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
}

.tag-operation-menu .menu-operate {
  /*margin: 5px 0;*/
  cursor: pointer;
  line-height: 26px;
  padding: 5px 0;
  font-size: 12px;
}

.menu-operate+.menu-operate {
  border-top: 1px solid #eee;
}

.tag-operation-menu .menu-operate span {
  display: block;
  padding: 0 20px;
  transition: color 0.3s;
  user-select: none;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  transition: none;
}

.tag-operation-menu .menu-operate:hover span {
  background: #4d7cff !important;
  color: #ffffff;
}

.tag-operation-menu button {
  width: 100px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Header/TagsBar.vue